export const timesheetRecordOptions: {name: string, value: string}[] = [
  {name: 'break', value: 'break'},
  {name: 'work', value: 'work'},
];